import {Attendee} from 'Event/attendee'
import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'

export type HighLevelTag = {
  name: string
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/high_level/add_tag`)
  return (tag: HighLevelTag) => {
    try {
      client.post(url, {
        name: tag,
      })
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/high_level/test_tag`)
  return async (tag: HighLevelTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      name: tag.name,
      attendee_id: attendee.id,
    })
  }
}
